import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge class names with clsx, then resolve Tailwind conflicts with
 * tailwind-merge (last-wins). The standard design-system class combiner.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Neutral icon-button tone — a gray-500 glyph that darkens to gray-600 over a
 * gray-100 hover background. The shared skin for low-emphasis icon triggers
 * (`CloseButton`'s default tone, the `HelpPopover` trigger, the `WidgetMenu`
 * kebab) so they can't drift apart. Consumers layer their own base/focus/size
 * classes on top via `cn`.
 *
 * The `data-[state=open]` classes mirror the hover skin so that when the button
 * is a Radix menu/popover trigger, it stays visually "active" while its overlay
 * is open (the mouse-driven `:hover` drops once the menu takes over). Radix only
 * stamps `data-state="open"` on trigger elements, so this is inert for the
 * non-trigger consumers (close buttons, etc.).
 */
export const neutralIconTone =
  'text-fbui-gray-500 hover:bg-fbui-gray-100 hover:text-fbui-gray-600 data-[state=open]:bg-fbui-gray-100 data-[state=open]:text-fbui-gray-600'
